// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2De2m","approved":"Status_approved__2oJVT","rejected":"Status_rejected__2ZijS","expired":"Status_expired__3A7DD","label":"Status_label__10ced"};